import SponsorPage from './Index.vue'

new Vue({
    el: '#app-vue',
    name: 'SponsorIndication',
    components: {
        SponsorPage,
    }
})
